import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { IconButton } from '@flipster/react/design-system/icon-button';
import { createTabsComponent } from '@flipster/react/design-system/tabs';
import XMarkIcon from '@flipster/react/icon/generated/XMarkIcon';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { useResize } from './resize';
import { Tab, devtoolsRouteBunja } from './state';
import { BuildInfo } from './tabs/build-info';
import { Brt } from './tabs/bunja/brt';
import { Dag } from './tabs/bunja/dag';
import { Flag } from './tabs/flag';
import { Logging } from './tabs/logging';

const Tabs = createTabsComponent<Tab>();

interface Props {
  onClose: () => void;
}

export const Panel = ({ onClose }: Props) => {
  const { height, onMouseDown, onTouchStart } = useResize();
  const { isBunjaDevtoolsEnabled, currentTabAtom, changeTab } = useBunja(devtoolsRouteBunja);
  const currentTab = useAtomValue(currentTabAtom);

  return (
    <>
      <div style={{ height }} />
      <aside
        className={stack({
          zIndex: 9999, // toast zIndex(10000) 보다 작아야 스낵바를 볼 수 있음
          pos: 'fixed',
          right: 0,
          bottom: 0,
          left: 0,
          bgColor: 'background.default.level-1',
          borderTopWidth: '1px',
          borderTopStyle: 'solid',
          borderTopColor: 'border.accent.promotion',
        })}
        style={{ height, flex: `1 1 ${height}px` }}
      >
        <div
          onMouseDown={onMouseDown}
          onTouchStart={onTouchStart}
          className={css({
            zIndex: 2,
            pos: 'absolute',
            top: 0,
            h: 4,
            w: '100%',
            cursor: 'ns-resize',
            _hover: {
              bgColor: 'border.accent.promotion',
            },
            _active: {
              bgColor: 'border.accent.promotion',
            },
          })}
        />
        <Tabs
          size='small'
          type='scrollable'
          value={currentTab}
          onChange={changeTab}
          css={stack.raw({ flex: 1, minH: 0 })}
          panelCss={{ flex: 1, minH: 0, overflowY: 'auto' }}
        >
          {isBunjaDevtoolsEnabled && (
            <>
              <Tabs.Tab value='brt' label='BRT'>
                <Brt />
              </Tabs.Tab>
              <Tabs.Tab value='dag' label='DAG'>
                <Dag />
              </Tabs.Tab>
            </>
          )}
          <Tabs.Tab value='flag' label='Flag'>
            <Flag />
          </Tabs.Tab>
          <Tabs.Tab value='logging' label='Logging'>
            <Logging />
          </Tabs.Tab>
          <Tabs.Tab value='build-info' label='Build Info'>
            <BuildInfo />
          </Tabs.Tab>
        </Tabs>
        <IconButton
          size='small'
          hierarchy='tertiary'
          icon={<XMarkIcon />}
          onClick={onClose}
          css={{ pos: 'absolute', top: 6, right: 12 }}
        />
      </aside>
    </>
  );
};
